<template>
  <div>    
    <b-card>
      <b-row class="mb-1" align-v="center">
        
        <b-col md="4">

          <b-form-group
            label="Building"
            label-for="building"
          >
            <v-select
              label="name"
              v-model="building"
              placeholder="Select Building"
              :options="buildings"
              autoscroll
              :clearable="true"
            ></v-select>
          </b-form-group>
        </b-col>
        
        <b-col md="4">
          <b-form-group
            label="Status"
            label-for="status"
          >
            <v-select
              label="name"
              v-model="status"
              placeholder="Select Status"
              :options="[{value: true, name: 'Active'},{value: false, name: 'Resolved'}]"
              autoscroll
              :clearable="true"
            ></v-select>
          </b-form-group>
        </b-col>
        
        
        <b-col md="4" class="text-right">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>&nbsp;
          <b-button variant="secondary" pill @click="resetSearch">
            <span class="align-middle">Reset</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="flood_emergency_data"
        details-td-class="m-0 p-0"
        small
        v-if="hasPermission('read_user')"
        :per-page="0"
        :tbody-tr-class="rowClass"
      > 
        <template #cell(name)="row">          
            {{
              row.item.user_flat_data ? row.item.user_flat_data.name : ""
            }}          
        </template>

        <template #cell(mobile_number)="row">          
            {{
              row.item.user_flat_data ? row.item.user_flat_data.mobile_number : ""
            }}          
        </template>

        <template #cell(building)="row">          
            {{
              row.item.user_flat_data ? row.item.user_flat_data.building : ""
            }}          
        </template>

        <template #cell(floor)="row">          
            {{
              row.item.user_flat_data ? row.item.user_flat_data.floor : ""
            }}          
        </template>

        <template #cell(resolve_status)="row">          
            {{
              row.item.resolve_status ? 'Resolved' : 'Active'
            }}          
        </template>

        <template #cell(manage)="row">
          <b-button
            variant="outline-success"
            pill
            size="sm"
            class="mr-50"
            @click="downloadImage(row.item.flood_image)"
          >
            Download
          </b-button>
        </template>  
      </b-table>
      <div class="row">
        <div class="col-md-11">
          <b-pagination
            size="md"
            :total-rows="totalItems"
            v-model="currentPage"
            :per-page="perPage"
          ></b-pagination>
        </div>
        <div class="col-md-1">
          <h4>
          Total: {{ totalItems }} 
          </h4>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import util from "@/util.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Reported by" },
        { key: "created_at", label: "Reported at" },
        { key: "mobile_number", label: "Contact" },
        { key: "building", label: "Building" },
        { key: "floor", label: "Floor" },
        { key: "resolve_status", label: "Status" },
        { key: "manage", label: "Image" },
      ],
      
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      flood_emergency_data: [],
      
      searchType: null,
      buildings: [],
      building : "",
      status : "",
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();
    const sites = await this.getSitesDDL();
    this.sites = sites.data;

    const buildings = await this.getBuildingsDDL();
    this.buildings = buildings.data;

    const floors = await this.getFloorsDDL();
    this.floors = floors.data;
  },
  methods: {
    ...mapActions({
      getSitesDDL: "appData/getSitesDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
      getFloorsDDL: "appData/getFloorsDDL",
      getFloodEmergency: "appData/getFloodEmergency",
      getFlatUsers: "appData/getFlatUsers",
    }),
    async search() {
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    resetSearch(){
        this.building = "";
        this.status = "";
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getFloodEmergency({
          pageNumber: this.currentPage,
          building : this.building.id,
          status : this.status.value,
        });
        this.flood_emergency_data = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    badgeVariant(status) {
      switch (status) {
        case 'Approved':
          return 'success';
        case 'Rejected':
          return 'danger';
        case 'Pending':
          return 'warning';
        case 'Left':
          return 'dark';
        default:
          return 'light';
      }
    },
    badgeVariantUserFlats(status) {
      switch (status) {
        case true:
          return 'success';
        case false:
          return 'danger';
        case null:
          return 'warning';
        
        default:
          return 'light';
      }
    },
    
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.in_building === true  && (item.exit_building === false || item.exit_building === null) && (item.reached_assembly_area === false || item.reached_assembly_area === null)) return 'table-danger'
      if (item.in_building === true  && item.exit_building === true && (item.reached_assembly_area === false || item.reached_assembly_area === null)) return 'table-primary'
      if (item.in_building === true && item.reached_assembly_area === true) return 'table-success'
    },

    downloadImage(imageUrl) {
      window.open(imageUrl, '_blank');
    },
  },
  computed: {
    ...mapGetters({ hasPermission: "appData/hasPermission", getLoggedInUser: "appData/getLoggedInUser" },
    ),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style scoped>
.amber-background {
  background-color: #ffbf00 !important;
}
</style>

